import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { startCase } from 'lodash-es';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Job } from '~hooks/useJob/models';
import { Load } from '~hooks/useLoad/models';
import { Ticket } from '~hooks/useTickets/models';
import { getTicketQuantityAndUom } from '~utils/tickets/ticket-utils';
import { numberToIntegerOrDecimal } from '~utils/utilFunctions';

interface QuantityColumnProps {
  job: Job;
  emptyPlaceholder?: string;
  load: Load;
  sx?: SxProps<Theme>;
  ticket?: Ticket;
}

export default function QuantityColumn({
  emptyPlaceholder = '-',
  job,
  load,
  sx,
  ticket,
}: QuantityColumnProps) {
  const quantityAndUom = getTicketQuantityAndUom(ticket, load, job);

  return (
    <Box sx={sx}>
      <OverflowAwareText>
        {quantityAndUom
          ? `${numberToIntegerOrDecimal(quantityAndUom.quantity)} ${startCase(quantityAndUom.uom)}`
          : emptyPlaceholder}
      </OverflowAwareText>
    </Box>
  );
}
